/*
 * 5-М8 «Записать к себе». Размеры из макета «Мастер - П0»: поле телефона 48 px
 * и 16 px шрифта (меньше — и мобильный браузер начинает масштабировать страницу
 * при фокусе), строки услуг не ниже 48 px, плитки времени 72×44, кнопка подвала 48 px.
 */

.head {
  flex: none;
}

.headText {
  padding: 0 var(--space-4) var(--space-2);
}

.title {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
}

.subtitle {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: var(--space-1) var(--space-4) var(--space-2);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.center {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  padding: var(--space-6);
  text-align: center;
}

.offlineTitle {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
}

.offlineText {
  margin: 0;
  font-size: var(--font-size-base);
  color: var(--text-secondary);
  line-height: 1.5;
}

/* ─────────── поля ─────────── */

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.fieldHead {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: var(--space-2);
}

.label {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
}

.myClients {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--accent);
  text-decoration: none;
  /* Цель нажатия дотягивается до 44 px по вертикали, не раздвигая строку подписи. */
  padding: 12px 0;
  margin: -12px 0;
}

.myClients:focus-visible {
  outline: var(--focus-ring-width) solid var(--focus-ring-color);
  outline-offset: var(--focus-ring-offset);
}

.input {
  height: var(--touch-min-target);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-strong);
  background: var(--bg-card);
  color: var(--text-primary);
  font: inherit;
  /* 16 px ровно: при меньшем размере мобильный Safari масштабирует страницу
     на фокусе, и форма уезжает из-под пальца. */
  font-size: 16px;
  font-variant-numeric: tabular-nums;
  padding: 0 12px;
  width: 100%;
}

.input:focus-visible {
  outline: none;
  border-color: var(--accent);
  box-shadow: var(--field-focus-ring);
}

/* Незаконченный ввод — не ошибка, а незавершённое действие: тон тёплый, а не красный. */
.inputHint {
  border-color: var(--master-hint-border);
}

.hint {
  margin: 0;
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  line-height: 1.4;
}

.newNote {
  margin: 0;
  font-size: var(--font-size-md);
  line-height: 1.45;
}

.failure {
  margin: 0;
  font-size: var(--font-size-md);
  color: var(--status-no-show-fg);
  line-height: 1.45;
}

/* ─────────── найденный клиент ─────────── */

.clientCard {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 10px 12px;
  background: var(--bg-card);
}

.avatar {
  width: 36px;
  height: 36px;
  flex: none;
  border-radius: 50%;
  background: var(--bg-sunken);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
}

.clientText {
  min-width: 0;
}

.clientName {
  margin: 0;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-base);
}

.clientSub {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.check {
  margin-left: auto;
  color: var(--accent);
  font-weight: 700;
}

/* ─────────── согласия ─────────── */

.consents {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 10px 12px;
  background: var(--bg-card);
}

/* Разделитель между двумя согласиями — не украшение: он показывает, что это ДВА
   разных документа, а не один длинный текст с одной галочкой. */
.consentSplit {
  height: 1px;
  background: var(--border);
}

/* ─────────── выбор услуги ─────────── */

.option {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  width: 100%;
  min-height: var(--touch-min-target);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 10px 12px;
  background: var(--bg-card);
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.optionActive {
  border-color: var(--accent);
  background: var(--master-accent-bg);
}

.option:focus-visible {
  outline: var(--focus-ring-width) solid var(--focus-ring-color);
  outline-offset: var(--focus-ring-offset);
}

.optionText {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.optionName {
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-base);
}

.optionSub {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.optionPrice {
  margin-left: auto;
  font-variant-numeric: tabular-nums;
  font-weight: var(--font-weight-semibold);
  white-space: nowrap;
}

/* ─────────── плитки времени ─────────── */

.times {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.slot {
  min-width: 72px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  background: var(--bg-card);
  color: var(--text-primary);
  font: inherit;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  font-variant-numeric: tabular-nums;
  cursor: pointer;
}

.slotActive {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--text-on-accent);
}

.slot:focus-visible {
  outline: var(--focus-ring-width) solid var(--focus-ring-color);
  outline-offset: var(--focus-ring-offset);
}

/* ─────────── «слот заняли» ─────────── */

.taken {
  border: 1px solid var(--border-strong);
  border-left: 3px solid var(--master-note-fg);
  border-radius: var(--radius-lg);
  padding: var(--space-3);
  background: var(--bg-card);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.takenTitle {
  margin: 0;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
}

.takenText {
  margin: 0;
  font-size: var(--font-size-md);
  line-height: 1.45;
  color: var(--text-secondary);
}

.takenRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}

.warnings {
  border-radius: var(--radius-lg);
  border: 1px solid var(--status-pending-fg);
  background: var(--status-pending-bg);
  color: var(--status-pending-fg);
  padding: var(--space-3);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.warningText {
  margin: 0;
  font-size: var(--font-size-md);
  line-height: 1.45;
}

/* ─────────── подвал ─────────── */

.footer {
  flex: none;
  border-top: 1px solid var(--border);
  padding: var(--space-2) var(--space-4) var(--space-3);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.submit {
  height: var(--touch-min-target);
  font-size: var(--font-size-base);
  border-radius: 12px;
}

.footerNote {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  text-align: center;
}
